import { Injectable, Inject } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { timeout, retry, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class WanService {
    private apiUrl = `${environment.apiHost}/wan`;

    constructor(private http: HttpClient, @Inject(OKTA_AUTH) public oktaAuth: OktaAuth) {
    }

    async getBandwidthUtilization(storeNumber: string) {
        return this.http.get(`${this.apiUrl}/bandwidth-utilization?storeNumber=${storeNumber}`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(6000),
                retry(3),
                catchError(error => of("Requests for bandwidth utilization timed out!"))
            );
    }

    async getInterfaceThroughput(storeNumber: string) {
        return this.http.get(`${this.apiUrl}/interface-throughput?storeNumber=${storeNumber}`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(3000),
                retry(3),
                catchError(error => of("Requests for interface throughput timed out!"))
            );
    }

    async getPosInterfaceThroughputTest(storeNumber: string) {
        return this.http.get(`${this.apiUrl}/pos-interface-throughput-test?storeNumber=${storeNumber}`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(3000),
                retry(3),
                catchError(error => of("Requests for pos interface throughput test timed out!"))
            );
    }

    async getThroughputTest(storeNumber: string) {
        return this.http.get(`${this.apiUrl}/throughput-test?storeNumber=${storeNumber}`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(6000),
                retry(3),
                catchError(error => of("Requests for throughout test timed out!"))
            );
    }

    async getStoreDashboardFromLogicMonitor(storeNumber: string) {
        return this.http.get(`${this.apiUrl}/logic-monitor-dashboard?storeNumber=${storeNumber}`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken(),
                    "Cache-Control": "max-age=0"
                }
                )
            }).pipe(
                timeout(6000),
                retry(3),
                catchError(error => of("Requests for the LogicMonitor store dashboard timed out!"))
            );
    }

    async getPosServices(storeNumber: string) {
        return this.http.get(`${this.apiUrl}/pos-services?storeNumber=${storeNumber}`,
        {
            headers: new HttpHeaders(
                { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken()
                
            }
            )
        }).pipe(
            timeout(3000),
            retry(3),
            catchError(error => of("Requests for the LogicMonitor POS Services timed out!"))
        );
    }

}